module.exports = __webpack_public_path__ + "login-360fc939/Background_01_1x1_a-03e20323ff9d4915efe975bccad105f6.svg";